<template>
  <div>
    <slot/>
  </div>
</template>

<script setup>
import Highcharts from "@/highcharts"
import { onMounted } from "vue"

const props = defineProps({
  year: Number,
  data: Object,
})

onMounted(() => {
  Highcharts.setOptions({ lang: { numericSymbols: ["k", " million", " billion"] } })

  const { year, data } = props

  const series = Object.keys(data).map((key) => {
    const { gc_color: color, title, schools } = data[key]

    return {
      name: title,
      data: Object.values(schools).map((school) => ({
        x: school.rate,
        y: school.previous_tuition_total,
        name: school.name,
      })),
      fillColor: color,
      marker: {
        symbol: "circle",
        fillColor: color,
      },
    }
  })

  const options = {
    chart: {
      type: "scatter",
      zoomType: false,
      height: 500,
    },
    title: { text: `Total Tuition Paid vs. Bar Exam Outcomes for ${year} Graduates` },
    xAxis: {
      title: { enabled: true, text: `Bar Passage Rate in ${year}` },
      labels: {
        formatter() {
          return `${this.value}%`
        },
      },
    },
    yAxis: {
      title: {
        text: "Total Tuition Paid",
      }, min: 0, max: 200000,
      labels: {
        formatter() {
          return `$${Math.round(this.value / 1000)}k`
        },
      },
      endOnTick: false,
    },
    plotOptions: {
      scatter: {
        marker: {
          radius: 5,
          states: {
            hover: {
              enabled: true,
              lineColor: "rgb(100,100,100)",
            },
          },
        },
        states: {
          hover: {
            marker: {
              enabled: false,
            },
          },
        },
      },
    },
    tooltip: {
      useHTML: true,
      formatter() {
        return `<b>${this.point.name}</b><br>Total Tuition Paid: $${Math.round(this.y / 1000)}k<br>Bar Pass: ${this.x}%`
      },
    },
    series,
  }

  new Highcharts.chart("tuitionVbar", options)
})
</script>
